import styled from 'styled-components';

export const Label = styled.div`
	font-size: 12px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	margin-bottom: 10px;
`;

export const HeaderBase = styled.div`
	padding-left: 12px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: transparent;
	padding-top: 8px;
	padding-bottom: 6px;
`;

export const HeaderLabel = styled.div`
	// layout
	display: flex;
	align-items: center;
	margin-bottom: 0px;
	margin-top: 0px;

	// style
	user-select: none;
	font-size: 17px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const HeaderActionsSection = styled.div`
	display: flex;
	gap: 0px;
	align-items: center;
	margin-top: 1px;
`;

// nested buttons are not allowed so we have a separate style for the dropdown trigger
export const DropdownTrigger = styled.div`
	background: transparent;
	border: none;
	border-radius: 6px;
	padding-left: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const Dimensions = styled.div`
	font-size: 12px;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[700]};
	margin-left: 13px;
`;

export const ThemeToggleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 2px;
	margin-left: 13px;
	margin-top: 6px;
`;

export const DsCard = styled.div`
	background: ${({ theme }) => {
		return theme.gray[0] === '#272727' ? '#2A2A2A' : theme.gray[100];
	}};
	border-radius: 8px;
	margin-top: 20px;
	margin-left: 12px;
	margin-right: 12px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	padding-top: 10px;
`;

export const DsHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding-left: 8px;
	padding-right: 8px;
	padding-bottom: 10px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const DsIcon = styled.div`
	color: ${({ theme }) => theme.gray[600]};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const DsName = styled.div`
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	flex: 1;
`;


export const DsModeSection = styled.div``;

export const DsModeOption = styled.button<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 6px;
	font-size: 13px;
	font-family: inherit;
	font-weight: ${({ $active }) => ($active ? 500 : 400)};
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ $active, theme }) => ($active ? theme.gray[200] : 'transparent')};
	border: none;
	width: 100%;
	text-align: left;
	transition: background-color 0.1s ease;

	&:hover {
		background: ${({ $active, theme }) => ($active ? theme.gray[200] : theme.gray[100])};
	}
`;

export const DsModeOptionSwatch = styled.div<{ $color: string }>`
	width: 14px;
	height: 14px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ $color }) => $color};
	flex-shrink: 0;
`;
